import { TFunction } from 'i18next';
import { createColumnHelper } from '@tanstack/react-table';
import {
  Badge,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from '@chakra-ui/react';
import { BranchRegion } from '@texas/api/endpoints/branchRegionsApi';
import { Icons } from '@texas/components/shared/Icons';

export const branchRegionTableColumns = (
  t: TFunction,
  onEditOpen: (id: number) => void,
) => {
  const columnHelper = createColumnHelper<BranchRegion>();
  const columns = [
    columnHelper.accessor('name', {
      cell: (info) => info.getValue(),
      header: t('general.name'),
      maxSize: 200,
    }),
    columnHelper.accessor('branches', {
      cell: (info) => (
        <Flex gap={2} flexWrap="wrap">
          {info.getValue().map((branch) => (
            <Badge key={branch.id} variant="configuration-reference">
              {branch.name} ({branch.erp})
            </Badge>
          ))}
        </Flex>
      ),
      header: t('general.branches'),
      enableSorting: false,
    }),
    columnHelper.accessor('id', {
      cell: (info) => (
        <>
          <Flex justifyContent="end" alignItems="center" gap={4}>
            <Menu>
              <MenuButton>
                <Icons.DotsHorizontal />
              </MenuButton>
              <Portal>
                <MenuList>
                  <MenuItem
                    icon={<Icons.Pencil />}
                    onClick={() => onEditOpen(info.getValue())}
                  >
                    {t('general.edit')}
                  </MenuItem>
                </MenuList>
              </Portal>
            </Menu>
          </Flex>
        </>
      ),
      header: '',
      enableSorting: false,
      maxSize: 100,
    }),
  ];

  return columns;
};
